import type { SiteControllerSettingTemairazuFormModel } from "@/components/features/settings/site-controller/model/temairazu/type";
import type { SiteControllerSettingTemairazuFormModelMethodsType } from "@/components/features/settings/site-controller/model/temairazu/use-case/use-create-model/methods";

import { SettingsSiteControllerTemairazuPassword } from "./password";
import { SettingsSiteControllerTemairazuSetUpRoomPriceByChillnn } from "./set-up-room-price-by-chillnn";

type Props = {
	temairazuViewModel: SiteControllerSettingTemairazuFormModel["ViewModel"]; //
	siteControllerSettingTemairazuFormModelMethodsType: SiteControllerSettingTemairazuFormModelMethodsType;
};

export const SettingsSiteControllerTemairazuMainSection = ({
	temairazuViewModel,
	siteControllerSettingTemairazuFormModelMethodsType,
}: Props) => {
	return (
		<>
			<SettingsSiteControllerTemairazuPassword
				hotelID={temairazuViewModel.hotelID}
				password={temairazuViewModel.password}
				onSetPassword={
					siteControllerSettingTemairazuFormModelMethodsType.siteControllerSettingNeppanFormModelMethods
						.onSetPassword
				}
			/>
			<SettingsSiteControllerTemairazuSetUpRoomPriceByChillnn
				setUpRoomPriceByChillnn={temairazuViewModel.setUpRoomPriceByChillnn}
				onSetSetUpRoomPriceByChillnn={
					siteControllerSettingTemairazuFormModelMethodsType.siteControllerSettingNeppanFormModelMethods
						.onSetSetUpRoomPriceByChillnn
				}
			/>
		</>
	);
};

SettingsSiteControllerTemairazuMainSection.displayName = "SettingsSiteControllerTemairazuMainSection";
